module.exports = __webpack_public_path__ + "static/assets/6860234c7e1c6f6d7ae3eea3b4949759.png";